import React from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, Search, FileText, Phone, User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { cn } from "@/lib/utils";

const MobileBottomNav: React.FC = () => {
  const { t } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const location = useLocation();
  const currentLang = lang || "en";
  const { user } = useAuth();

  const tabs = [
    { icon: Home, labelKey: "nav_home", path: "" },
    { icon: Search, labelKey: "nav_horses", path: "/horses?filters=open" },
    { icon: User, labelKey: user ? "nav_account" : "nav_login", path: user ? "/account" : "/auth" },
    { icon: Phone, labelKey: "nav_contact", path: "/contact" },
  ];

  const isActive = (path: string) => {
    const fullPath = `/${currentLang}${path}`;
    if (path === "") return location.pathname === `/${currentLang}` || location.pathname === `/${currentLang}/`;
    return location.pathname.startsWith(fullPath);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border sm:hidden">
      <div className="flex items-center justify-around h-16 px-2 pb-[env(safe-area-inset-bottom)]">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.path);
          return (
            <Link
              key={tab.path}
              to={`/${currentLang}${tab.path}`}
              className={cn(
                "flex flex-col items-center justify-center gap-0.5 flex-1 py-1 transition-colors",
                active
                  ? "text-accent"
                  : "text-muted-foreground"
              )}
            >
              <Icon className={cn("w-5 h-5", active && "stroke-[2.5]")} />
              <span className="text-[10px] font-medium leading-tight">{t(tab.labelKey)}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
